import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import PreferenceFormPage from './pages/PreferenceForm';
import ExternalRedirect, {
  HOME_REDIRECT_URL,
} from './components/ExternalRedirect';

const router = createBrowserRouter([
  {
    path: '/preferences/:token',
    element: <PreferenceFormPage />,
  },
  {
    path: '*',
    element: <ExternalRedirect to={HOME_REDIRECT_URL} />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
